import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { URL_BASE } from '../../core/constants';
import { map } from 'rxjs/operators';
import { AutoCompleteAddress } from '../auto-complete-address.model';
import { HttpUtils } from '../http-utils';

@Injectable()
export class AutoCompleteAddressService {

  private AUTO_COMPLETE_ADDRESS_URI = 'routing/auto-complete-address';

  constructor(private http: HttpClient) {
  }

  public search(q: string): Observable<Array<AutoCompleteAddress>> {
    const headers = HttpUtils.createHeaders();

    return this.http.get(`${URL_BASE}/api/${this.AUTO_COMPLETE_ADDRESS_URI}/search?q=${q}`, { headers })
      .pipe(
        map((result: any[]) => result.map(data => AutoCompleteAddress.fromDto(data)))
      );
  }
}
